import type {
  Driver,
  DriverArgument,
  DriverArguments,
  DriverUnits,
} from '@automata/wfb-api';
import uniq from 'lodash/uniq';

import drivers from './realDrivers.json';

export type { Driver, DriverArgument, DriverArguments };

export type DriverConfiguration = Driver['configuration'];

export type DriverParameterType = DriverArgument['type'];

export type ParameterUnit = 'rpm' | 'celsius';

export type ParameterDisplayFieldType = 'time'; // TODO(IL, 2024-03-27): what other display field types?

export type DriversByNameAndVersion = {
  [driverName: string]: { [driverVersion: string]: Driver };
};

export function getDriver(
  drivers: DriversByNameAndVersion,
  args: { driverName: string; driverVersion: string }
): Driver | undefined {
  const { driverName, driverVersion } = args;
  return drivers[driverName]?.[driverVersion];
}

// TODO(IL, 2024-03-25): this is just to populate redux store
export const getDriversSync = (): Driver[] => drivers as unknown as Driver[];

export function getAllowedTaskNames(
  drivers: Driver[],
  blockList: readonly string[]
): string[] {
  const taskNames = uniq(
    drivers.reduce<string[]>(
      (acc, driver) => [
        ...acc,
        ...Object.keys(driver.actions).filter(
          (action) => !blockList.includes(action)
        ),
      ],
      []
    )
  );
  taskNames.sort();
  return taskNames;
}

export function parameterUnitDisplayText(unit: DriverUnits): string | null {
  switch (unit) {
    case 'celsius':
      return '°C';
    case 'rpm':
      return 'RPM';
    case 'seconds':
      return null;
  }
  unit satisfies never;
  return null;
}
